// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-fa60cdae]{background-color:#214282}.img_caption[data-v-fa60cdae]{cursor:pointer;position:absolute;top:10%;left:20%;width:60%;text-align:center;overflow:hidden;text-overflow:ellipsis;background-color:hsla(0,0%,100%,.6);-webkit-backdrop-filter:blur(10px) opacity(50%);backdrop-filter:blur(10px) opacity(50%);border-radius:.25em;padding:10px}.cntr[data-v-fa60cdae]{justify-content:center}.spc-btwn[data-v-fa60cdae]{justify-content:space-between}", ""]);
// Exports
module.exports = exports;
